
































































































import DialogService from '~/services/DialogService';
import WorkAuthorizationItem from './WorkAuthorizationItem.vue';
import EducationSkeleton from '../skeletons/EducationSkeleton.vue';

// Data
import countries from 'highered-utils/data/countries.json';
import { Candidate, WorkAuthorization } from '~/services/CandidateService';
import { User } from '~/services/IdentityService';

import { PropType } from 'vue';
import Vue from 'vue';
import { IMissingFieldValidation } from '~/utils/user/validateCandidateData';
import { TranslateResult } from 'vue-i18n';

const countryMap = countries.reduce((map, country) => map.set(country.value, country), new Map());

const ETHNIC_MINORITY_YES = 'yes';
const ETHNIC_MINORITY_NO = 'no';
const ETHNIC_MINORITY_PREFER_NOT_TO_SAY = 'prefer_not_to_say';

export default Vue.extend({
    name: 'WorkAuthorization',
    components: {
        WorkAuthorizationItem,
        EducationSkeleton,
    },
    props: {
        value: {
            // WorkAuthorizations
            type: Array as PropType<WorkAuthorization[]>,
            default: () => [],
        },
        candidateData: {
            type: Object as PropType<Candidate>,
            required: true,
        },
        user: {
            type: Object as PropType<User>,
            required: true,
        },
        isLoading: {
            type: Boolean,
            default: () => true,
        },
        requiredFields: {
            type: Object as PropType<IMissingFieldValidation>,
            required: true,
        },
    },
    data: () => ({
        countries,
    }),
    computed: {
        locationAuthed(): Boolean {
            return this.value
                .map((workAuth: WorkAuthorization) => workAuth.code)
                .includes(this.candidateData.country || '');
        },
        locationDisabled(): Boolean {
            return this.user.nationality === this.candidateData.country;
        },
        nationality(): { value: any; label: any } {
            const country = countryMap.get(this.user.nationality);
            if (country) {
                return {
                    value: country.value,
                    label: country.label,
                };
            } else {
                return {
                    value: null,
                    label: '',
                };
            }
        },
        country() {
            const country = countryMap.get(this.candidateData.country);
            if (country) {
                return {
                    value: country.value,
                    label: country.label,
                };
            } else {
                return {
                    value: null,
                    label: '',
                };
            }
        },
    },
    methods: {
        requiredFieldParser(message: string, required: boolean): string {
            return message.concat(required ? ':*' : ':');
        },
        listChanged(newValue: WorkAuthorization[]) {
            this.$emit('change');
            this.$emit('input', newValue || this.value);
        },
        onAdd(data: any) {
            this.listChanged(this.value.concat(data));
        },
        onClose() {},
        openModal() {
            DialogService.openWorkAuthorizationDialog(
                {
                    existing: this.value,
                },
                {
                    onAdd: this.onAdd,
                    close: this.onClose,
                }
            );
        },
        onItemDeleted(code: string) {
            this.listChanged(this.value.filter(w => w.code !== code || w.implicit));
        },
        onNationalityChange(newVal: any) {
            this.$emit('user:change', {
                ...this.user,
                nationality: newVal ? newVal.value : null,
            });
        },
        onCountryChange(newVal: any) {
            // current location
            this.$emit('candidate:change', {
                ...this.candidateData,
                country: newVal ? newVal.value : null,
            });
        },
        onEthnicMinorityChange(newVal: string) {
            this.$emit('candidate:change', {
                ...this.candidateData,
                ethnicMinority: newVal,
            });
        },
        onLocationAuthChange(newVal: string) {
            const country = countryMap.get(this.candidateData.country);
            if (newVal && country) {
                this.onAdd({
                    type: 0,
                    code: country.value,
                    implicit: false,
                });
            } else if (!newVal && country) {
                this.onItemDeleted(country.value);
            }
        },
        getEthnicMinorityOptions(): { value: string; label: TranslateResult }[] {
            return [
                {
                    value: ETHNIC_MINORITY_YES,
                    label: this.$t('spotlight.workAuthorization.ethnicMinorityOptions.yes'),
                },
                {
                    value: ETHNIC_MINORITY_NO,
                    label: this.$t('spotlight.workAuthorization.ethnicMinorityOptions.no'),
                },
                {
                    value: ETHNIC_MINORITY_PREFER_NOT_TO_SAY,
                    label: this.$t(
                        'spotlight.workAuthorization.ethnicMinorityOptions.preferNotToSay'
                    ),
                },
            ];
        },
    },
});
